import { Component, Inject } from '@angular/core';
import { MdDialog, MD_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { MagicBoxRuleShort } from '../../models/magicbox-rule-short';
import { MagicBoxService } from '../../services/magic-box.service';
import { SuccessComponent } from '../success/success.component';

@Component({
  selector: 'app-delete-generated-fields',
  templateUrl: './delete-generated-fields.component.html',
  styleUrls: ['./delete-generated-fields.component.scss']
})
export class DeleteGeneratedFieldsComponent {

  magicBoxRuleShorts: MagicBoxRuleShort[];

  /**
   * Initialize variables with the modal config
   * @param data
   */
  constructor(@Inject(MD_DIALOG_DATA) public data: MagicBoxRuleShort[],
    private router: Router,
    private magicBoxService: MagicBoxService,
    private mdDialog: MdDialog) {
    this.magicBoxRuleShorts = data;
  }

  switchDeleteAll() {
    const allAreSelected = this.allAreSelected();
    this.magicBoxRuleShorts.map(rule => {
      rule.toDelete = !allAreSelected;
    });

  }

  allAreSelected() {
    return this.magicBoxRuleShorts.filter(rule => rule.toDelete).length === this.magicBoxRuleShorts.length;
  }

  delete() {
    const message = 'Rules has been deleted';

    this.magicBoxService.deleteFieldsGenerated(this.magicBoxRuleShorts).subscribe(res => {
      this.mdDialog.closeAll();
      this.mdDialog.open(SuccessComponent, { data: { message } });
      this.router.navigate(['/', 'magicbox']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/delete-generated-fields/delete-generated-fields.component.ts